import { render, staticRenderFns } from "./showPaper.vue?vue&type=template&id=68dfc669&scoped=true&"
import script from "./showPaper.vue?vue&type=script&lang=js&"
export * from "./showPaper.vue?vue&type=script&lang=js&"
import style0 from "./showPaper.vue?vue&type=style&index=0&id=68dfc669&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dfc669",
  null
  
)

export default component.exports